import { Tooltip } from "@mui/material";
import { ICandidateEmailAddress, ICandidatePhoneNumber } from "../../../App/Typings/Candidate";
import { ReactNode } from "react";
import { HighlightOff } from "@mui/icons-material";
import { formatPhone } from "../../../App/Utilities/formatUtilities";

export const DisplayPhoneNumber = ({
  phone,
  prefix,
  suffix,
}: {
  phone: ICandidatePhoneNumber;
  prefix?: ReactNode;
  suffix?: ReactNode;
}) => {
  if (!phone.isValid || !phone.validationAttempt) {
    const title = !phone.validationAttempt ? "Verification pending" : "Invalid phone number";
    return (
      <Tooltip arrow title={title}>
        <span
          style={{
            minWidth: "19ch",
            display: "flex",
            alignItems: "center",
            gap: 1,
            opacity: !phone.validationAttempt ? "0.7" : "1",
          }}
        >
          {prefix}
          {formatPhone(phone.phoneNumber)}
          {suffix}{" "}
          {phone.validationAttempt && !phone.isValid && <HighlightOff fontSize="small" color="error" />}
        </span>
      </Tooltip>
    );
  } else if (phone.phoneNumber) {
    return (
      <span
        style={{
          minWidth: "19ch",
          display: "block",
        }}
      >
        {prefix}
        {formatPhone(phone.phoneNumber)}
        {suffix}
      </span>
    );
  }
  return <></>;
};

export const DisplayEmailAddress = ({
  email,
  prefix,
  suffix,
}: {
  email: ICandidateEmailAddress;
  prefix?: ReactNode;
  suffix?: ReactNode;
}) => {
  if (!email.isValid || !email.validationAttempt) {
    const title = !email.validationAttempt ? "Verification pending" : "Invalid email address";
    return (
      <Tooltip arrow title={title}>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            opacity: !email.validationAttempt ? "0.7" : "1",
          }}
        >
          {prefix}
          {email.emailAddress}
          {suffix}
          {email.validationAttempt && !email.isValid && <HighlightOff fontSize="small" color="error" />}
        </span>
      </Tooltip>
    );
  } else if (email.emailAddress) {
    return (
      <span style={{ display: "block" }}>
        {prefix}
        {email.emailAddress}
        {suffix}
      </span>
    );
  }
  return <></>;
};
